"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SecondaryButton_1 = require("../../Buttons/SecondaryButton");
var Graphics_1 = require("../../Graphics");
var EmptyState_styles_1 = require("./EmptyState.styles");
exports.default = (function (_a) {
    var GraphicType = _a.GraphicType, HeaderText = _a.HeaderText, DescriptionText = _a.DescriptionText, ActionCaption = _a.ActionCaption, HandleAction = _a.HandleAction, IsSmall = _a.IsSmall;
    return (React.createElement(EmptyState_styles_1.ControlContainer, { IsSmall: IsSmall },
        React.createElement(EmptyState_styles_1.GraphicWrapper, null,
            React.createElement(Graphics_1.Graphic, { Graphic: GraphicType })),
        React.createElement(EmptyState_styles_1.Container, { IsSmall: IsSmall },
            React.createElement(EmptyState_styles_1.H3, null, HeaderText),
            DescriptionText &&
                React.createElement(EmptyState_styles_1.P, null, DescriptionText),
            (HandleAction && ActionCaption) &&
                React.createElement(SecondaryButton_1.SecondaryButton, { OnClick: HandleAction, Caption: ActionCaption }))));
});
